/**
 * A tiny event bus so any code path that discovers the MSAL session is truly
 * dead (silent refresh + popup fallback both failed) can signal it, without
 * every caller needing to know how to force a sign-out. SessionGate is the
 * sole subscriber — it clears the local MSAL cache and routes to /session-expired.
 */

export const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired';

const authEventBus = new EventTarget();

export function emitSessionExpired(message?: string): void {
    authEventBus.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, { detail: { message } }));
}

export function onSessionExpired(handler: (message?: string) => void): () => void {
    const listener = (e: Event) => handler((e as CustomEvent).detail?.message);
    authEventBus.addEventListener(AUTH_SESSION_EXPIRED_EVENT, listener);
    return () => authEventBus.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, listener);
}
